
export default [
    {
      path: "/empty-legs",
      meta: {
        requiresAuth: false,
        permission: null,
        title: "Piernas vacias",
        layout: "admin",
        module: "empty-legs",
        icon: "mdi-airplane",
        notBreadCrumb: true,
      },
      component: () =>
        import(/* webpackChunkName: "emptyLegsLayout" */ "@/views/empty-legs/EmptyLegsLayout.vue"),
      children: [
        {
          path: "",
          name: "empty-legs-list",
          meta: {
            requiresAuth: true,
            permission: null,
            layout: "admin",
            module: "empty-legs",
            title: "Listados",
            adminLayoutNav: true,
            icon: "mdi-format-list-bulleted",
            notBreadCrumb: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "emptyLegsList" */ "@/views/empty-legs/EmptyLegsList.vue"
            ),
        },
        {
          path: "buyers",
          name: "empty-legs-buyers",
          meta: {
            requiresAuth: true,
            permission: null,
            layout: "admin",
            module: "empty-legs",
            title: "Interesados",
            adminLayoutNav: true,
            icon: "mdi-cash",
            notBreadCrumb: true,
          },
          component: () =>
            import(
              /* webpackChunkName: "emptyLegsBuyers" */ "@/views/empty-legs/EmptyLegsBuyers.vue"
            ),
        },
      ],
    },
  ];
  